import { registrations } from '../registrations';
import IntersectionHydrator from './IntersectionHydrator';
new IntersectionHydrator(registrations);
